<template>
  <div class="all-style">
    <Layout :visual="visual" :state="state">
      <div class="contact-style">
        <div style="height: 15%"></div>
        <!-- <img src="@/assets/img/product/productimg.gif" alt=""> -->
        <div class="connection-style">
          <div class="connectiontext-style">{{ productInfo.name }}</div>
          <div class="blueline-style"></div>
          <div class="code-style">{{ productInfo.model }}</div>
          <div class="contacttext-style">
            {{ productInfo.briefIntroduction }}
          </div>
        </div>
      </div>
      <div class="info-style">
        <div style="height: 50px"></div>
        <div class="category-style">
          <div class="one-style" v-if="type !== '6'">
            <div class="deepblue-style"></div>
            <div class="productcategory-style">{{ titletext }}</div>

            <div class="productList-style"></div>
            <div v-for="(item, index) in productList" :key="index">
              <div
                :class="
                  pilestate === index
                    ? 'productListtext-stylechoice'
                    : 'productListtext-style'
                "
                @click="classificationpile(item, index)"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
         
        </div>
        <div style="height: 50px"   v-if="type !== '6'"></div>
         <div
            v-if="type == '6'"
            class="productcategory-style"
            style="margin-top: 20px; text-align: center"
          >
            以下产品图片仅供参考
          </div>
        <div class="news-style">
          <div class="newsList-style">
            <div
              style="margin-top: 30px; width: 500px"
              v-for="(item, index) in newsList"
              :key="index"
              @click="jumpdetails(item)"
            >
              <div class="newsListimg-style">
                <div style="height: 24px"></div>
                <div class="newsListtitle-style" v-if="item.productName">{{ item.productName }}</div>
                <div class="newsListcontent-style" v-if="item.productTitle">
                  {{ item.productTitle }}
                </div>
                <div class="newsimg-style">
                  <img
                    style="width: 100%; height: 100%"
                    :src="item.productImages"
                    alt=""
                  />
                </div>
              </div>
              <!-- v-if="type !== '6'" -->
              <div class="newsListtext-style">
                <div style="height: 20px"></div>
                <div class="see-style">查看详情</div>
                <div style="height: 20px"></div>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 56px"></div>
        <!-- <div class="load-style">
          <div>加载更多</div>
          <img
            style="margin-left: 5px"
            src="@/assets/img/Layout/dropdown.png"
            alt=""
          />
        </div> -->
      </div>
    </Layout>
  </div>
</template>

<script>
import Layout from "@/components/Layout/Layout.vue";
export default {
  name: "",
  props: {},
  components: {
    Layout,
  },
  data() {
    return {
      code: "GEAC007A",
      visual: 1,
      state: 2,
      pilestate: "",
      text: "我们的交流充电桩专为电动汽车设计，具备高效、安全、稳定的充电能力。采用标准交流电输出，适配广泛的车型，确保充电过程平稳可靠。充电桩内置智能管理系统，能够自动检测车辆充电需求，优化充电功率，避免电池过度充电或过热。外壳采用耐用材料，防水防尘设计，适合室内外各种环境使用。简洁的操作界面和多种充电模式选择，满足用户的多样化需求，让您的电动汽车时刻保持最佳状态。",
      oneInfo: {
        img: require("@/assets/img/journalism/one.png"),
        titlename: "2024年首秀︱第61届中国高等教育博览会",
        content:
          "2024年4月15日，第61届中国高等教育博览会在福州海峡国际会展中心揭开帷幕，据悉，中国高等教育博览会始创于1992年，是全国高等教育领域内规模最大、影响力最广泛的综合性品牌博览会。本届高博会将以“职普融通·产教融合·科教融汇”为主题，服务教育、科技、人才“三位一体”协同发展。主体活动主要由“展览展示”和“高质量学术交流活动”两大板块构成。",
        date: "2024/04/16",
      },
      newsList: [],
      productList: [],
      type: "",
      typeProperty: "",
      titletext: "",
      productInfo: {},
    };
  },
  watch: {
    "$route.query.type": {
      handler(newVal, oldVal) {
        this.getProductList();
      },
      immediate: true,
    },
  },
  created() {
    this.type = this.$route.query.type;
    if (this.$route.query.typeProperty) {
      this.typeProperty = this.$route.query.typeProperty;
      this.pilestate = this.$route.query.typeProperty - 1;
    } else {
      this.typeProperty = "";
      this.pilestate = "";
    }

    if (this.type == 1) {
      this.titletext = "智能充电桩";
      this.productList = [
        {
          label: "3.5KW",
        },
        {
          label: "7KW",
        },
        {
          label: "11KW",
        },
        {
          label: "22KW",
        },
      ];
    }
    if (this.type == 4) {
      this.titletext = "实验电源";
      this.productList = [
        {
          label: "单路",
        },
        {
          label: "多路",
        },
      ];
    }
    if (this.type == 5) {
      this.titletext = "设备电源";
      this.productList = [
        {
          label: "模块电源",
        },
        {
          label: "板卡电源",
        },
      ];
    }
    if (this.type == 3) {
      this.titletext = "光伏逆变器";
      this.productList = [
        {
          label: "600W",
        },
      ];
    }
    if (this.type == 2) {
      this.titletext = "车载充电机";
      this.productList = [
        {
          label: "铅酸版",
        },
        {
          label: "锂电版",
        },
      ];
    }
    if (this.type == 7) {
      this.titletext = "集成测试系统 | 按需定制";
      this.productList = [];
    }
    this.getProductList();
  },

  mounted() {},

  methods: {
    refreshPage() {
      // 获取当前路由的fullPath
      const path = this.$route.fullPath;
      // 强制刷新页面
      this.$router.replace({ path, force: true });
    },
    jumpdetails(e) {
      // if (this.type !== "6") {
        this.$router.push({
          path: "/productdetails",
          query: { no: e.no },
        });
      // }
    },
       
    classificationpile(e, i) {
      if (this.pilestate !== i) {
        this.pilestate = i;
        this.typeProperty = this.pilestate + 1;
        this.getProductList();
      } else {
        this.pilestate = "";
        this.typeProperty = "";
        this.getProductList();
      }
    },
    // 获取产品列表
    getProductList() {
      this.$api
        .getProduct({
          type: this.type,
          typeProperty: this.typeProperty,
        })
        .then((res) => {
          if (res.code == 200) {
            this.productInfo = res.data;
            this.newsList = this.productInfo.productList;
          }
        })
        .catch((err) => {});
    },
  },

  computed: {},

  watch: {},
};
</script>

<style lang='scss' scoped>
.all-style {
  width: 100%;
  height: 100%;
  cursor: pointer;
  overflow-x: hidden;
}
.contact-style {
  background-image: url("../../assets/img/product/productimg.gif");
  background-size: cover;
  width: 100%;
  height: 860px;
  margin-top: 80px;
}
.connection-style {
  width: 100%;
  height: 100%;
  // border: 1px solid rgb(0, 0, 0);
}
.connectiontext-style {
  // margin-top: 10%;
  color: #303133;
  margin-left: 8.3%;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  font-size: 40px;
  line-height: 60px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.blueline-style {
  width: 120px;
  height: 4px;
  background: #1092f5;
  border-radius: 0px 0px 0px 0px;
  margin-left: 8.3%;
  margin-top: 12px;
}
.code-style {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 40px;
  color: #303133;
  line-height: 60px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-left: 8.3%;
  margin-top: 72px;
}
.contacttext-style {
  width: 640px;
  height: 120px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #616266;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-left: 8.3%;
  margin-top: 24px;
}
.info-style {
  width: 100%;
  background: #f7f7f7;
  border-radius: 0px 0px 0px 0px;
}
.category-style {
  width: 80%;
  height: 100%;
  margin-left: 8.3%;
}
.one-style {
  display: flex;
  width: 100%;
}
.deepblue-style {
  width: 4px;
  height: 16px;
  background: #0a5d9c;
  border-radius: 0px 0px 0px 0px;
  margin-top: 12px;
}
.productList-style {
  margin-left: 14px;
}
.productListtext-style {
  width: 96px;
  height: 40px;
  background: #ffffff;
  border-radius: 6px 6px 6px 6px;
  border: 1px solid #c2c5cc;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #616266;
  line-height: 40px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin-left: 16px;
}
.productListtext-stylechoice {
  width: 96px;
  height: 40px;
  background: #0a5d9c;
  border-radius: 6px 6px 6px 6px;
  border: 1px solid #c2c5cc;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: white;
  line-height: 40px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin-left: 16px;
}
.productcategory-style {
  // width: 64px;
  height: 24px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 600;
  font-size: 16px;
  color: #303133;
  line-height: 24px;

  font-style: normal;
  text-transform: none;
  margin-top: 8px;
  margin-left: 5px;
}
.firstimg-style {
  width: 50%;
  height: 100%;
}
.right-style {
  width: 50%;
  height: 100%;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
}
.news-style {
  width: 90%;
  // height: 800px;
  // border: 1px solid black;
  margin-left: 8.3%;
}
.newsList-style {
  display: flex;
  // justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
}
.newsListimg-style {
  width: 90%;
  // height: 288px;
  // background: #ffffff;
  // border: 1px solid black;
}
.newsListtext-style {
  width: 96%;
  // height: 218px;
  // background: #ffffff;
  border-radius: 0px 0px 0px 0px;
}
.pattern-style {
  padding: 24px;
  // margin-left: 24px;
}
.see-style {
  width: 80%;
  height: 40px;
  border-radius: 6px 6px 6px 6px;
  border: 1px solid #c2c5cc;
  margin-left: 10%;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #303133;
  line-height: 40px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.newsListtitle-style {
  width: 100%;
  // width: 450px;
  height: 60px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 20px;
  color: #303133;
  line-height: 30px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  // padding: 24px;
}
.newsListcontent-style {
  // width: 450px;
  width: 100%;
  height: 44px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #616266;
  line-height: 22px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin-top: -18px;
}
.newsimg-style {
  width: 80%;
  height: 400px;
  margin-left: 10%;
}
.newsListdata-style {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 12px;
  color: #919399;
  line-height: 18px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 24px;
}
.load-style {
  width: 100%;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #616266;
  line-height: 22px;
  // text-align: center;
  font-style: normal;
  text-transform: none;
  margin-top: 24px;
  padding-bottom: 72px;
  display: flex;
  margin-left: 50%;
}
</style>